export default __webpack_public_path__ + "static/mckay-e4565b28de33f51e76a5f5a013932af1.jpg";